export const tagMap = {
    0: null, 
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6',
  };

  export const PAGE_LOGIN_TYPE = {
    ANONYMOUS: 0,
    OTP: 1,
    OTP_EXTENDED: 2,
    CREDENTIALS: 3,
    CREDENTIALS_ORG_EMPLOYEE_FAMILY: 4,
  };